

<template>
  <div class="businessScope">
    <div class="main">
      <div class="top-search">
        <div class="item">
          <span>注册地：</span>
          <div>
            <el-autocomplete
              v-model="input"
              :fetch-suggestions="querySearch"
              @select="handleSelect"
              placeholder="请选择注册地"
              @click="handleSelectClick"
            ></el-autocomplete>
          </div>
        </div>
        <div class="item">
          <span style="width: 30px;"></span>
          <el-button type="primary" @click="queryCtlPage" size="small">搜索</el-button>
          <el-button type="primary" plain size="small">重置</el-button>
        </div>
      </div>
      <div class="left-button">
        <el-button
          type="primary"
          @click="dialogVisible1 = true, ruleForm.id = '', dialogTitle = '新增'" size="small"
        >新增</el-button>
        <el-button type="danger" @click="deleteData" size="small">删除</el-button>
      </div>
      <div class="bottom-table">
        <el-table
          :data="tableData"
          @select="domicileSelect"
          @select-all="domicileSelectAll"
          border
          :header-cell-style="{background:'rgb(250, 250, 250)'}"
          style="width: 100%"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column fixed="left" prop="domicile.name" label="注册地" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="id" label="经营范围编码" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="businessType" label="经营范围" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="businessscope" label="经营范围详情" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="isEnabled" label="是否启用" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="created_at" label="创建时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" label="操作" width="100">
            <template slot-scope="scope">
              <div style="cursor: pointer;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-button
                        @click="editOperation(scope.row)"
                        type="danger"
                        size="mini"
                        plain
                      >&emsp;编辑&emsp;</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      width="700px"
      :visible.sync="dialogVisible1"
      :before-close="handleClose"
    >
      <div style="width:600px;">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="注册地" prop="input">
            <div class="dialog-input">
              <!-- <el-autocomplete v-model="input" :fetch-suggestions="querySearchPopup" @select="handleSelectTow" placeholder="输入注册地"></el-autocomplete> -->
              <el-autocomplete
                v-model="ruleFormInput"
                :fetch-suggestions="querySearch"
                @select="handleSelectTow"
                placeholder="输入注册地"
                @click="handleSelectClick"
              ></el-autocomplete>
            </div>
          </el-form-item>

          <el-form-item label="经营范围" prop="businesssType">
            <div class="dialog-input">
              <el-input v-model="ruleForm.businesssType"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="经营范围详情" prop="businessscope">
            <!-- <div class="dialog-input"><el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="ruleForm.desc"></el-input></div> -->
            <el-input
              type="textarea"
              placeholder="请输入内容"
              rows="4"
              resize="none"
              v-model="ruleForm.businessscope"
            ></el-input>
          </el-form-item>
          <div style="padding-top: 15px;">
            <!-- @click="cancelForm" -->
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
export default {
  data() {
    return {
      input: "",
      dialogTitle: "新增",
      total: null,
      pageSzie: 10,
      restaurants: [], //注册地数据
      restaurantsPopup: [], //弹出框注册地数据
      tableData: [], //经营范围列表
      domicileAll: [], //所有注册地模糊搜索
      dialogVisible1: false, // 控制两个dialog
      scopeBusinessID: [], //经营范围id数组
      addressTow: "", //点击添加时存储id
      textarea2: "",
      ruleFormInput: "",
      ruleForm: {
        id: "",
        domicileId: "",
        businessscope: "",
        businesssType: ""
      },
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      rules: {
        businesssType: [
          { required: true, message: "请输入经营范围", trigger: "blur" }
        ],
        // input:[
        //   { required: true, message: '请输入活动名称', trigger: 'blur' },
        //   { min: 0, max:95, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        // ],
        businessscope: [
          { required: true, message: "请填写经营范围详情", trigger: "blur" }
        ]
      },
      domicileIds: [],
      currentPage: null
    };
  },
  components: {
    pagination: pagination
  },
  mounted() {
    var that = this;
    // 注册地列表
    that.domicileCtlNameList();
    // 调用post请求经营范围列表
    that.businessscopeCtlPage(); // 调用弹出框post注册地经营列表
    //       that.businessscopeCtlInfo()
    // 弹出框经营范围列表数据
    // that.restaurantsPopup=that.domicileAllPopup
    //请求经营范围添加/修改接口
    // that.businessscopeCtlSave()
  },
  methods: {
    // 注册地列表
    domicileCtlNameList() {
      post(api.domicileCtlNameList, {}).then(
        d => {
          if (d.status === 0) {
            console.log(d.data, "注册地列表");
            var that = this,
              rows = d.data;
            that.domicileAll = [];
            for (let i = 0; i < rows.length; i++) {
              that.domicileAll.push({
                value: rows[i].name,
                address: rows[i].id
              });
            }
            // var rows=d.data.rows
            // // 调用注册地经营列表数据处理
            // that.businessData(rows)
          } else {
          }
        },
        err => {}
      );
    },

    // 请求post注册地经营列表
    businessscopeCtlPage(address) {
      const loading = this.$loading({
        lock: true,
        spinner: "loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      post(api.businessscopeCtlPage, {
        currentPage: this.currentPage,
        pageSize: this.pageSzie,
        domicileId: address
      }).then(
        d => {
          console.log(d, "dddddddeeeeeeee");
          var that = this;
          loading.close();
          if (d.status === 0) {
            this.total = d.data.count;
            var rows = d.data.rows;
            // 调用注册地经营列表数据处理
            that.businessData(rows);
          } else {
          }
        },
        err => {}
      );
    },

    // 请求弹出框post注册地经营列表
    // businessscopeCtlInfo(addressId){
    //  post(api.businessscopeCtlInfo, {
    //      "id": addressId           // 经营范围id
    //   })
    //   .then((d) => {
    //     console.log(d,'请求弹出框post注册地经营列表1')
    //     var that=this
    //     if (d.status === 0) {
    //        var rows=d.data.rows
    //      // 调用注册地经营列表数据处理
    //       that.businessData(rows)
    //     }else {}
    //   }, (err) => {
    //   //error callback
    //   })
    // },

    //请求经营范围添加/修改接口
    businessscopeCtlSave(obj) {
      post(api.businessscopeCtlSave, obj).then(
        d => {
          if (d.status === 0) {
            this.dialogVisible1 = false; // 控制两个dialog
            console.log(d, "wwwwwwwwwwwwwwwwwwwwwdddddddddddd1");
            this.businessscopeCtlPage();
          } else {
          }
        },
        err => {
          //error callback
        }
      );
    },

    // 点击删除按钮请求数据接口
    businessscopeCtlDel(array) {
      post(api.businessscopeCtlDel, {
        ids: array // 经营范围id数组
      }).then(
        d => {
          if (d.status === 0) {
            console.log(d, "点击删除按钮请求数据");
            this.businessscopeCtlPage();
          } else {
          }
        },
        err => {
          //error callback
        }
      );
    },
    // 点击input触发
    handleSelectClick() {
      var that = this;
      // 注册地列表
      that.domicileCtlNameList();
    },
    //注册地经营列表数据处理
    businessData(rows) {
      console.log(rows, "rowsrowsrows");
      var that = this;
      if (rows.length) {
        // 清空经营范围列表数据
        that.tableData = [];
        // that.scopeBusinessID=[]
        for (let i = 0; i < rows.length; i++) {
          that.tableData.push(rows[i]);
          // that.scopeBusinessID=that.scopeBusinessID.concat(rows[i].domicile.id)
          // console.log( that.scopeBusinessID,' that.scopeBusinessID')
        }
        // 经营范围列表数据
        that.restaurants = that.domicileAll;
        // 清空所有注册地模糊搜索数据
        that.domicileAll = [];
      }
    },
    domicileSelectAll(arr) {
      console.log(arr);
      this.domicileIds = [];
      for (let i = 0; i < arr.length; i++) {
        this.domicileIds.push(arr[i].id);
      }
    },
    domicileSelect(arr, row) {
      console.log(arr);
      this.domicileIds = [];
      for (let i = 0; i < arr.length; i++) {
        this.domicileIds.push(arr[i].id);
      }
    },
    //点击删除按钮触发函数
    deleteData() {
      if (this.domicileIds.length == 0) {
        return;
      }
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.businessscopeCtlDel(this.domicileIds); // 调用删除按钮给后台传值
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });

      // that.businessscopeCtlPage() //重新调用加载列表数据
    },

    //注册地查询列表选择某产品事件
    handleSelect(item) {
      console.log(item, "itemitem");
      var that = this;
      that.businessscopeCtlPage(item.address); // 调用post请求经营范围查询
    },

    //注册地查询列表某产品事件
    handleSelectTow(item) {
      console.log(item);
      var that = this;
      this.ruleForm.domicileId = item.address;
      that.addressTow = item.address; // 调用弹出框post注册地经营列表
    },

    // 点击搜索按钮触发
    queryCtlPage() {
      var that = this,
        domicileAll = that.domicileAll;
      that.businessscopeCtlPage(domicileAll.address); // 调用post请求经营范围查询
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible1 = false;
    },
    // 点击弹出框确定按钮
    submitForm(formName) {
      var that = this;
      // console.log(that.addressTow,'addressTow')
      // 调用post请求经营范围查询
      // that.businessscopeCtlSave('',that.addressTow)
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.businessscopeCtlSave(this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    handleSizeChange(val) {
      this.pageSzie = val;
      console.log(`每页 ${val} 条aaaaa`);
      this.businessscopeCtlPage();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}aaaaaaaaaaaaaaaa`);
      this.businessscopeCtlPage();
    },
    editOperation(row) {
      this.dialogTitle = "编辑";
      post(api.businessscopeCtlInfo, {
        id: row.id
      }).then(
        d => {
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.ruleForm.id = d.data.id;
            this.ruleFormInput = d.data.domicile.name;
            this.ruleForm.domicileId = d.data.domicileId;
            this.ruleForm.businessscope = d.data.businessscope;
            this.ruleForm.businesssType = d.data.businessType;
            this.dialogVisible1 = true;
          } else {
            this.ruleForm.id = row.id;
            this.ruleForm.domicileId = row.domicileId;
            this.ruleForm.businessscope = row.businessscope;
            this.ruleForm.businesssType = row.businessType;
            this.dialogVisible1 = true;
            console.log(d.msg);
          }
        },
        err => {
          //error callback
        }
      );
    },
    handleClose(done) {
      this.$refs.ruleForm.resetFields();
      done();
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    // createFilterPopup(queryString) {
    //   return (restaurant) => {
    //     return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //   };
    // },
    // 注册地数据
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    }
    // // 弹出框注册地数据
    // querySearchPopup(queryString, cb){
    //   var restaurantsPopup = this.restaurantsPopup;
    //   var results = queryString ? restaurantsPopup.filter(this.createFilter(queryString)) : restaurantsPopup;
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },
  }
};
</script>

<style lang="less" scoped>
.businessScope {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      overflow: hidden;
      .item {
        height: 46px;
        line-height: 46px;
        float: left;
        margin-bottom: 10px;
        span {
          display: inline-block;
          // width: 110px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 233px;
          height: 46px;
        }
      }
    }
    .left-button {
      text-align: left;
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
    .dialog-header {
      width: 100%;
      height: 49px;
      line-height: 49px;
      background: rgba(20, 147, 250, 0.1);
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: #333333;
      text-align: left;
      div {
        float: left;
        width: 116px;
        height: 49px;
        background: rgba(20, 147, 250, 1);
        color: #ffffff;
        text-align: center;
        margin-right: 28px;
      }
    }
    .dialong-content {
      width: 100%;
      height: 565px;
      background: rgba(216, 216, 216, 0.28);
      margin-top: 23px;
    }
  }
  .details {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content {
      width: 100%;
      .name {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        background: rgba(250, 250, 250, 1);
        border-radius: 6px;
        text-align: left;
        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 0px 55px;
          line-height: 36px;
        }
      }
      .box1 {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: left;
        overflow: hidden;
        .item {
          float: left;
          height: 93px;
          margin-right: 100px;
          margin-bottom: 20px;
          div {
            float: left;
            min-width: 55px;
            height: 93px;
          }
          .picture {
            width: 167px;
            height: 93px;
            background: rgba(246, 246, 246, 1);
            border-radius: 8px;
            border: 1px solid rgba(198, 198, 198, 1);
          }
        }
      }
    }
  }
  .dialog-input {
    width: 350px;
    height: 40px;
    text-align: left;
  }
  .dialog-input-text {
    width: 350px;
    height: 60px;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/system/maintenance/businessScope.vue